import React, { useEffect } from "react";

function Bookings(props) {
  useEffect(() => {
    document.title = `${props.pageTitle} - The Kinneuchar Inn`;

    if (props.pageImage) {
      document.body.style.backgroundImage = `url(${props.pageImage.fields.file.url})`;
      document.body.classList.add("has-image");
    }

    return () => {
      document.body.classList.remove("has-image");
      document.body.style.backgroundImage = "none";
    };
  });

  return (
    <div className="Bookings">
      <h1>{props.pageTitle}</h1>
      <div dangerouslySetInnerHTML={{ __html: props.pageContent }}></div>
      <iframe
        src="https://www.sevenrooms.com/reservations/kinneucharinn"
        width="100%"
        height="800"
        title="Reservation form"
      ></iframe>
    </div>
  );
}

export default Bookings;
